export default __webpack_public_path__ + "static/media/CutedCabezal_Tablilla.29ba8057.jpg";